import { ExpressionError } from './expression.error';
export class ExpressionExtensionError extends ExpressionError {
}
//# sourceMappingURL=expression-extension.error.js.map